module.exports = __webpack_public_path__ + "img/menu-board-thai-express.990bfe23.jpg";